export enum TSSchadenArt {
    ERDRUTSCH = <any> 'ERDRUTSCH',
    UEBERSCHWEMMUNG = <any> 'UEBERSCHWEMMUNG',
    UEBERFUEHRUNG = <any> 'UEBERFUEHRUNG',
    RUEFE = <any> 'RUEFE',
    LAWINE = <any> 'LAWINE',
    SCHNEEDRUCK = <any> 'SCHNEEDRUCK',
    STURMWIND = <any> 'STURMWIND',
    FELSSTURZ = <any> 'FELSSTURZ',
    STEINSCHLAG = <any> 'STEINSCHLAG',
    TROCKENHEIT = <any> 'TROCKENHEIT',
    ANDERE = <any> 'ANDERE'
}

export function getTSSchadenArtValues(): Array<TSSchadenArt> {
    return [
        TSSchadenArt.ERDRUTSCH,
        TSSchadenArt.UEBERSCHWEMMUNG,
        TSSchadenArt.UEBERFUEHRUNG,
        TSSchadenArt.RUEFE,
        TSSchadenArt.LAWINE,
        TSSchadenArt.SCHNEEDRUCK,
        TSSchadenArt.STURMWIND,
        TSSchadenArt.FELSSTURZ,
        TSSchadenArt.STEINSCHLAG,
        TSSchadenArt.TROCKENHEIT,
        TSSchadenArt.ANDERE
    ];
}
export function schadenartPrefix(): string {
    return 'TSSchadenArt_';
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSSchadenArt.ts